module.exports = App.PromosController = Em.Controller.extend
  env:     Em.inject.service('environment')
  advertsEnabled: Em.computed.alias('env.features.advertsEnabled')
  promosEnabled: Em.computed.alias('env.features.promosEnabled')
  loyaltyEnabled: Em.computed.alias('env.features.loyaltyProgramsEnabled')
  clientTagsEnabled:   Em.computed.alias('env.features.enableClientTagAutoassign')

  restaurants: Ember.computed ->
    @store.find('restaurant')